import { createUrl } from "./urlQueryHelper.js";

export function saveDataListState(page, rowsPerPage, dataListFilter, dataListSort, columnsSettings) {
  if (!history.pushState) {
    return;
  }
  const newurl = createUrl(page, rowsPerPage, dataListFilter, dataListSort, columnsSettings);
  window.history.pushState({ path: newurl }, "", newurl);
}